import React from "react";
import { Typography } from "antd";

export const EmptyPanel = ({ title, description }: { title: string; description: string }): React.ReactElement => (
  <div className="flex min-h-48 flex-col items-center justify-center rounded-lg border border-dashed border-gray-200 bg-gray-50 px-6 text-center">
    <Typography.Text className="font-medium text-gray-700">{title}</Typography.Text>
    <Typography.Text className="mt-1 max-w-md text-sm text-gray-500">{description}</Typography.Text>
  </div>
);
